import type { JSX } from 'react';

import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

export const LayoutAltTopIcon = (props: SVGProps): JSX.Element => {
  return <SpriteIcon spriteId="layout-alt-top" {...props} />;
};
